import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';
import AboutContent from '../components/About/AboutContent';
import DocsHub from '../components/About/DocsHub';
import $ from 'jquery';

export default function About() {
  const [searchParams] = useSearchParams();
  const hasParams = searchParams.has('section') || searchParams.has('version');

  useEffect(() => {
    $('.popover').hide();
  }, []);

  return (
    <>
      <Helmet>
        <title>DISGENET: Database Information</title>
        <meta name="description" content="Information about database statistics, attributes and metrics." />
        <link rel="canonical" href="/docs" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="DISGENET: Database Information" />
        <meta
          name="twitter:description"
          content="Information about database statistics, attributes and metrics."
        />
        <meta name="twitter:image" content="../public/static/images/LOGO_DISGENET.svg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.disgenet.com/docs" />
        <meta property="og:title" content="DISGENET: Database Information" />
        <meta
          property="og:description"
          content="Explore detailed information about database statistics, attributes, and metrics on DISGENET."
        />
        <meta property="og:image" content="../public/static/images/LOGO_DISGENET.svg" />
      </Helmet>
      {hasParams ? <AboutContent /> : <DocsHub />}
    </>
  );
}
